import { render } from "./HeaderMain.vue?vue&type=template&id=4c4cfa1d"
const script = {}

import "./HeaderMain.vue?vue&type=style&index=0&id=4c4cfa1d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__